/**
 * Created by pery on 29/07/2015.
 */
module.exports = angular.module(__filename,[
    require('./am-value.drv/am-value.drv').name,
    require('./space-after.drv/space-after.drv').name,
    require('./loading-notation.drv/loading-notation.drv.js').name
]);